import { render, staticRenderFns } from "./Comorbidities.vue?vue&type=template&id=0f87503d"
import script from "./Comorbidities.vue?vue&type=script&lang=ts"
export * from "./Comorbidities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports